import React from "react";
import Grid from "@material-ui/core/Grid";

// import Logo from "./logo.png";
import Logo from "./logo.svg";
import { Typography } from "@material-ui/core";

function Header({ partner }) {
    return (
        <Grid
            container
            justify="center"
            alignItems="center"
            style={{ background: "#2f2939" }}
        >
            <Grid
                container
                direction="row"
                wrap="nowrap"
                className="header-container"
                style={{ maxHeight: 70, minHeight: 70, maxWidth: 1140 }}
            >
                <Grid
                    container
                    direction="row"
                    wrap="nowrap"
                    alignItems="center"
                    style={{
                        marginRight: 25,
                        width: "fit-content",
                    }}
                >
                    <img
                        src={Logo}
                        className="header-logo"
                        alt="Стекло24. Срочное изготовление стеклоизделий в Москве"
                        title="Стекло24. Срочное изготовление стеклоизделий в Москве"
                    />
                    <Typography
                        className="header-logo-text"
                        style={{
                            textTransform: "uppercase",
                            fontWeight: 700,
                            marginLeft: 12,
                            color: "#ffffff",
                        }}
                    >
                        стекло24
                    </Typography>
                </Grid>

                <Grid
                    container
                    direction="column"
                    className="header-text-container"
                    style={{
                        paddingLeft: 20,
                        borderLeft: "3px solid #fff",
                    }}
                >
                    <Typography
                        className="header-text"
                        style={{ color: "#ffffff" }}
                    >
                        г. Москва
                    </Typography>
                    <Typography
                        className="header-text"
                        style={{ color: "#ffffff" }}
                    >
                        Дмитровское шоссе, д.13
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        className="header-phone"
                        align="right"
                        noWrap
                        style={{ color: "#ffffff" }}
                    >
                        {partner && partner.phone
                            ? partner.phone
                            : "+7 495 649-61-45"}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.jsx